import React, { useState } from 'react';
import {
  AvatarContainer,
  AvatarImg,
  ErrorMessage,
  LoadingAnimation,
} from './AvatarThumbnail.styled';

type AvatarState = 'loading' | 'error' | 'ok';

type AvatarThumbnailProps = {
  src: string;
  name: string;
};

const AvatarThumbnail = ({ src, name }: AvatarThumbnailProps) => {
  const [state, setState] = useState<AvatarState>('loading');

  if (state === 'error') {
    return (
      <AvatarContainer>
        <ErrorMessage>{name}</ErrorMessage>
      </AvatarContainer>
    );
  }

  return (
    <AvatarContainer>
      <AvatarImg
        src={src}
        alt={name}
        onLoad={() => setState('ok')}
        onError={(e) => {
          e.stopPropagation();
          setState('error');
        }}
      />
      {state === 'loading' && (
        <LoadingAnimation data-testid="loading-animation" />
      )}
    </AvatarContainer>
  );
};

export default AvatarThumbnail;
